module.exports = __webpack_public_path__ + "static/media/finsite_premium.712e9f55.png";